<template>
  <collapsable
    :collapsed="collapsed"
    :title="$t('entities.evohealth_health_groups.title', {name: entity.name})"
  >
    <div v-if="isFetchingServer">
      <LoadingAnimation class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation>
    </div>
    <div v-else>
      <div class="row evollu-form mt-3" v-if="allHealthGroups.length > 0">
          <div class="col-12">
            <div>
              <multiselect
                v-model="vmodelHealthGroups"
                :options="allHealthGroups"
                track-by="id"
                :customLabel="val => $t(`evohealth.healthGroups.${val.name}`, val.name)"
                select-label=""
                selected-label=""
                deselect-label=""
                :placeholder="$t('entities.evohealth_health_groups.title', {name: entity.name})"
                :allow-empty="true"
                :multiple="true"
                :close-on-select="false"
                :searchable="true">
                <template slot="clear">
                <span class="multiselect__clear" v-if="vmodelHealthGroups.length > 0"
                      @mousedown.prevent.stop="vmodelHealthGroups = []"></span>
                </template>
              </multiselect>
            </div>
        </div>

        <div class="row col-12 d-flex justify-content-end mt-3" v-if="changesDetected">
          <va-button @click.prevent="update">
            {{ $t('agenda.availability.save') }}
          </va-button>
        </div>
      </div>
      <div v-else class="row col-12 text-center">
        <span class="is-bold" style="font-size: 20px">{{ $t('clinical.people.no_data') }}</span>
      </div>
    </div>

    <div v-show="showLoadingIndicator">
      <LoadingAnimation :size="'5px'" class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation>
    </div>
  </collapsable>
</template>

<script>
import LoadingAnimation from '@/components/common/LoadingAnimation.vue';
import Collapsable from '@/components/common/Collapsable.vue';
import { AuthEvohealthService } from '@/api/AuthService';
import { EvohealthService } from '@/api/EvohealthService';
import Multiselect from 'vue-multiselect';

export default {
  components: { Multiselect, Collapsable, LoadingAnimation },
  props: {
    entity: {
      type: Object,
      required: true
    },
    collapsed: {
      type: Boolean,
      required: false
    },
    limitItems: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      isFetchingServer: false,
      showLoadingIndicator: false,
      permitableHealthGroups: [],
      completeHealthGroups: [],
      vmodelHealthGroups: [],
      allHealthGroups: []
    }
  },
  async created() {
    this.allHealthGroups = await EvohealthService.getHealthGroups()
    this.allHealthGroups = this.allHealthGroups.filter(elem => parseInt(elem.id) !== 2)
  },
  methods: {
    setLoadingState: async function(loading) {
      if (loading) {
        this.isFetchingServer = true;
      } else {
        setTimeout(() => {
          this.isFetchingServer = false
        }, 300)
      }
    },
    processHealthGroups: async function(healthGroups) {
      if (!healthGroups || !healthGroups.length) return [];

      const healthGroupsIds = healthGroups.map(elem => elem.evohealthHealthGroupId);
      if (!healthGroupsIds.length) return [];

      return await EvohealthService.getHealthGroupsByIds(healthGroupsIds.join(','));
    },
    handleError: async function(error) {
      console.error('Operation failed:', error);
      this.showToast(
        this.$t('roles.something_went_wrong'),
        this.$store.state.errorToastOptions
      );
    },
    fetchData: async function() {
      await this.setLoadingState(true);
      try {
        this.permitableHealthGroups = await AuthEvohealthService.getEntityHealthGroups(this.entity.id);
        this.completeHealthGroups = await this.processHealthGroups(this.permitableHealthGroups);
        this.vmodelHealthGroups = this.completeHealthGroups;
      } catch (error) {
        await this.handleError(error);
      } finally {
        await this.setLoadingState(false);
      }
    },
    update: async function() {
      await this.setLoadingState(true);
      try {
        const updatedGroups = this.vmodelHealthGroups.map(elem => parseInt(elem.id));
        this.permitableHealthGroups = await AuthEvohealthService.updateEntityHealthGroups(
          this.entity.id,
          updatedGroups
        );
        this.completeHealthGroups = await this.processHealthGroups(this.permitableHealthGroups);
        this.vmodelHealthGroups = this.completeHealthGroups;
      } catch (error) {
        await this.handleError(error);
        this.vmodelHealthGroups = this.completeHealthGroups;
      } finally {
        await this.setLoadingState(false);
      }
    }
  },
  computed: {
    changesDetected: function() {
      if (!this.completeHealthGroups || !this.vmodelHealthGroups) {
        return false;
      }
      const originalIds = new Set(this.completeHealthGroups.map(group => group.id));
      const currentIds = new Set(this.vmodelHealthGroups.map(group => group.id));

      return [...originalIds].some(id => !currentIds.has(id)) || [...currentIds].some(id => !originalIds.has(id));
    }
  },
  watch: {
    entity: {
      handler() {
        this.fetchData();
      },
      immediate: true
    }
  }
};
</script>

<style scoped lang="scss">

</style>
